import { HeaderNull } from "../../../component/HeaderNull";
import { useState, useEffect } from "react";
import { Table, Spin, Select } from "antd";
import {
  getFromlocalstorage,
  getFromsessionstorage,
} from "../../../component/MaHoaDuLieu";

const { Option } = Select;

function LichSuNapRut() {
  const [tab, setTab] = useState("ฝากเงิน");
  const [filterType, setFilterType] = useState("all");
  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(true);

  const apiUrl = process.env.REACT_APP_API_BACKEND;

  const storedData =
    getFromsessionstorage("data_u") || getFromlocalstorage("data_u");

  const user = storedData ? JSON.parse(storedData) : null;
  const userId = user?.id;

  // =========================
  // LẤY LỊCH SỬ GIAO DỊCH
  // =========================
  useEffect(() => {
    if (!userId) {
      setLoading(false);
      return;
    }

    let isMounted = true;

    const fetchData = async () => {
      try {
        const res = await fetch(`${apiUrl}/getlichsugd/${userId}`);
        const json = await res.json();

        if (isMounted) {
          setAllData(json);
        }
      } catch (err) {
        console.error("เกิดข้อผิดพลาดในการดึงข้อมูล:", err);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [userId, apiUrl]);

  // =========================
  // MAP LOẠI GIAO DỊCH
  // VIỆT NAM -> THÁI LAN
  // =========================
  const typeMap = {
    "Nạp tiền pháp định": "ฝากเงิน THB",
    "Rút tiền pháp định": "ถอนเงิน THB",
    "Nạp-Crypto": "ฝากเงิน USDT",
    "Rút-Crypto": "ถอนเงิน USDT",
  };

  // =========================
  // MAP TRẠNG THÁI
  // VIỆT NAM -> THÁI LAN
  // =========================
  const statusMap = {
    "Chờ xử lý": "รอดำเนินการ",
    "Đang xử lý": "กำลังดำเนินการ",

    "Thành công": "สำเร็จ",
    "Hoàn thành": "สำเร็จ",
    "Đã duyệt": "อนุมัติแล้ว",

    "Thất bại": "ไม่สำเร็จ",
    "Từ chối": "ถูกปฏิเสธ",

    "Đã hủy": "ยกเลิก",
    "Hủy": "ยกเลิก",
  };

  // =========================
  // CỘT BẢNG
  // =========================
  const columns = [
    {
      title: "เวลา",
      dataIndex: "created",
      key: "created",
    },
    {
      title: "วิธีการ",
      dataIndex: "type",
      key: "type",
      render: (value) => typeMap[value] || value,
    },
    {
      title: "จำนวนเงิน",
      dataIndex: "amount",
      key: "amount",
      render: (value) =>

        (Number(value || 0) / 1000).toLocaleString("en-US"),
    },
    {
      title: "สถานะ",
      dataIndex: "status",
      key: "status",
      render: (value) => statusMap[value] || value,
    },
  ];

  // =========================
  // BƯỚC 1:
  // LỌC THEO TAB NẠP / RÚT
  // =========================
  let filteredData =
    tab === "ฝากเงิน"
      ? allData.filter(
        (item) =>
          item.type === "Nạp tiền pháp định" ||
          item.type === "Nạp-Crypto"
      )
      : allData.filter(
        (item) =>
          item.type === "Rút tiền pháp định" ||
          item.type === "Rút-Crypto"
      );

  // =========================
  // BƯỚC 2:
  // LỌC THB / USDT
  // =========================
  if (filterType !== "all") {
    filteredData = filteredData.filter((item) => {
      if (filterType === "phapdinh") {
        return (
          item.type === "Nạp tiền pháp định" ||
          item.type === "Rút tiền pháp định"
        );
      }

      if (filterType === "crypto") {
        return (
          item.type === "Nạp-Crypto" ||
          item.type === "Rút-Crypto"
        );
      }

      return true;
    });
  }

  return (
    <div>
      <HeaderNull
        title={"ประวัติฝาก-ถอน"}
        link={"/usermobile"}
      />

      <div style={{ marginTop: "60px" }}>
        {/* =========================
            TAB NẠP / RÚT
        ========================= */}
        <div className="tab_naptien">
          <div
            className={`tab_panel_van ${tab === "ฝากเงิน"
              ? "tab-login"
              : "tab-register"
              }`}
          >
            {["ฝากเงิน", "ถอนเงิน"].map((item, index) => (
              <div
                key={index}
                className={`tab_panel_tab ${tab === item
                  ? "tab_panel_tab_active"
                  : ""
                  }`}
                onClick={() => setTab(item)}
              >
                {item}
              </div>
            ))}
          </div>
        </div>

        {/* =========================
            FILTER THB / USDT
        ========================= */}
        <div
          style={{
            margin: "100px 0 10px 10px",
          }}
        >
          <Select
            value={filterType}
            onChange={(value) => setFilterType(value)}
            style={{ width: 200 }}
          >
            <Option value="all">
              ทั้งหมด
            </Option>

            <Option value="phapdinh">
              THB
            </Option>

            <Option value="crypto">
              USDT
            </Option>
          </Select>
        </div>

        {/* =========================
            TABLE
        ========================= */}
        {loading ? (
          <Spin />
        ) : (
          <Table
            dataSource={filteredData.map((row, i) => ({
              key: i,
              ...row,
            }))}
            columns={columns}
            pagination={false}
            locale={{
              emptyText: "ไม่มีข้อมูล",
            }}
          />
        )}
      </div>
    </div>
  );
}

export default LichSuNapRut;